const DATE_FORMATS = {
  full_YMD_dash: 'yyyy-MM-dd',
  full_DMY_dot: 'dd.MM.yyyy',
  yyyy_MM_dd: 'yyyy-MM-dd',
};

export default DATE_FORMATS;
